'use client'

import { usePathname } from 'next/navigation'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import BottomNav from '@/components/BottomNav'
import PWAInstall from '@/components/PWAInstall'
import { ToastContainer } from '@/components/ui/ToastContainer'
import ThemeManager from '@/components/ThemeManager'
import { ThemeProvider, useTheme } from '@/contexts/ThemeContext'
import PageTracker from '@/components/PageTracker'

function LayoutContent({ children }: { children: React.ReactNode }) {
  const { theme } = useTheme()
  const pathname = usePathname()

  // 채팅방 상세 페이지 체크 (자체 레이아웃 사용)
  const isChatRoom = pathname?.match(/^\/chat\/[^/]+$/)

  // 채팅방 페이지는 완전히 독립적인 레이아웃 사용
  if (isChatRoom) {
    return (
      <div className={theme === 'light' ? 'bg-gray-50' : 'bg-gray-900'}>
        {children}
        <ToastContainer position="top-right" />
      </div>
    )
  }

  return (
    <div className={`min-h-screen flex flex-col ${
      theme === 'light'
        ? 'bg-gray-50'
        : 'bg-gray-900'
    }`}>
      <Header />
      <main className="flex-1 pt-14 xxs:pt-16 pb-20">
        {children}
      </main>
      {/* 모바일에서는 하단 네비게이션, 데스크톱에서는 푸터 */}
      <div className="hidden md:block">
        <Footer />
      </div>
      <div className="md:hidden">
        <BottomNav />
      </div>
      <PWAInstall />
      <ToastContainer position="top-right" />
    </div>
  )
}

export default function ConditionalLayout({ children }: { children: React.ReactNode }) {
  // /chat 페이지는 별도 layout.tsx에서 처리하므로 여기서는 항상 기본 레이아웃 렌더링
  return (
    <ThemeProvider>
      <ThemeManager />
      <PageTracker />
      <LayoutContent>{children}</LayoutContent>
    </ThemeProvider>
  )
}
